<div class="card panel-flat-color primary-panel flex-panel">
    <div class="panel-flat-header ws-flex-container-horizontal">
        <h3 class="ws-truncate ws-flex-auto">
            Additional Reports
            <ag-grid-row-count [gridApi]="gridApi" [gridOptions]="gridOptions" [cssClass]="null"></ag-grid-row-count>
        </h3>
        <div class="ws-flex-none header-button-container">
            @if (!editMode && canEdit) {
                <button
                    title="Edit"
                    type="button"
                    class="ace-btn btn-text has-icon btn-primary"
                    [disabled]="!canEnterEditMode"
                    (click)="edit()">
                    <i class="fa fa-pencil fa-align"></i>
                </button>
            }
            @if (editMode) {
                <button title="Add Reports"
                        type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        (click)="add()">
                    <i class="fa fa-plus-circle fa-align"></i>
                </button>
            }
            @if (editMode) {
                <button title="Save"
                        type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        [disabled]="!hasChanges"
                        (click)="save()">
                    <i class="fa fa-save fa-align"></i>
                </button>
            }
            @if (editMode) {
                <button title="Cancel"
                        type="button"
                        class="ace-btn btn-text has-icon btn-primary"
                        (click)="cancel()">
                    <i class="fa fa-times fa-align"></i>
                </button>
            }
            <ag-grid-filter-toggle [gridApi]="gridApi"></ag-grid-filter-toggle>
        </div>
    </div>
    <div class="panel-flat-body">
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
    </div>
</div>
